import * as action_types from "./constants";
import { DriveTimeResponse } from "./types";

export type myCompanyState = {
  driveTimeData: {
    data: DriveTimeResponse | null;
    loading?: boolean;
  };
};

const initialState: myCompanyState = {
  driveTimeData: {
    data: null,
    loading: true,
  },
};

type MyCompanyActionType = {
  type: typeof action_types.GET_DRIVE_TIME;
  data: {
    payload: DriveTimeResponse | null;
    loading?: boolean;
  };
};

const myCompanyReducer = (
  state = initialState,
  action: MyCompanyActionType
): myCompanyState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_DRIVE_TIME:
      return {
        ...state,
        driveTimeData: {
          data: data.payload,
          loading: data.loading,
        },
      };

    default:
      return state;
  }
};

export default myCompanyReducer;
